import { render } from "./AppNavbar.vue?vue&type=template&id=00c7b49c&scoped=true"
import script from "./AppNavbar.vue?vue&type=script&lang=ts"
export * from "./AppNavbar.vue?vue&type=script&lang=ts"

import "./AppNavbar.vue?vue&type=style&index=0&id=00c7b49c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00c7b49c"

export default script